import Article from './article';
import Inventaire from './inventaire';
import Transfert from './transfert';
import Stock from './stock';
import Mouvement from './mouvement';

export default [
  ...Article,
  ...Inventaire,
  ...Transfert,
  ...Stock,
  ...Mouvement,
];
